// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingGears_loadingContainer__6V6Tx","loadingText":"LoadingGears_loadingText__U-gps"};